/**
 * Rules engine for the Technical Sheet module.
 *
 * Defines interdependencies between parameters:
 * - When type = 'chemical': dimensions are not applicable, so useDimensions is disabled.
 * - When type = 'metalurgical': useDimensions can be freely configured.
 */
export const technicalSheetRules = {
    evaluate(params) {
        const disabled = {};
        const reasons = {};
        if (params.type === 'chemical') {
            disabled['useDimensions'] = true;
            reasons['useDimensions'] = 'Fichas químicas não utilizam dimensões';
        }
        return { disabled, reasons };
    },
    validate(_params) {
        // No cross-field validation needed for now
        return [];
    },
    coerce(params) {
        // If the user switches to 'chemical', reset useDimensions to false
        // because it has no meaning for chemical sheets
        if (params.type === 'chemical' && params.useDimensions) {
            return { useDimensions: false };
        }
        return {};
    },
};
//# sourceMappingURL=technicalSheet.rules.js.map